/**
 * 语音文本队列
 *
 * 保存等待TTS处理的句子
 */

export default class SentenceQueue{
    constructor(){
        this.queue=[];
    }

    /**
     * 添加句子
     *
     * @param text 文本
     */
    push(text){
        if(!text){
            return;
        }

        this.queue.push(text);
    }

    /**
     * 获取第一个任务
     */
    shift(){
        return this.queue.shift();
    }

    /**
     * 查看当前队列
     */
    peek(){
        return this.queue[0];
    }

    /**
     * 是否为空
     */
    isEmpty(){
        return this.queue.length===0;
    }

    /**
     * 清空
     */
    clear(){
        this.queue=[];
    }

    /**
     * 当前数量
     */
    size(){
        return this.queue.length;
    }
}